<template>
	<div class="board">
		<transition-group name="board-content" class="board-content">

			<div v-for="card in game.board" :key="card.id" class="board-card" :class="card.animation" :data-position="card.position">
				<board-card v-if="card" :card="card" />
			</div>
			<div class="board-card" :key="hero.id" :data-position="hero.position">
				<board-card :card="hero" />
			</div>

			<dropzone v-for="dropzone in dropzones" :dropzone="dropzone" :key="dropzone.id" :data-position="dropzone.position" />

		</transition-group>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Dropzone from '@/components/game/dropzone'
import BoardCard from '@/components/game/board-card'

export default {
	name: 'board',
	computed: {
		...mapGetters([ 'game', 'hero' ]),
		dropzones() {
			const dropzones = []
			for (var i = 0; i < 21; i++) {
				dropzones.push({ id: 'dropzone' + i, position: i, card: this.hero.position === i ? this.hero : this.game.board.find(c => c.position === i) })
			}
			return dropzones
		}
	},
	components: { Dropzone, BoardCard }
}
</script>

<style lang="stylus" scoped>

.board
	height cell_height
	width (cell_width * 7)
	// left 'calc(50% - %s)' % round(@width / 2)
	// left 0
	// flex flex-start flex-start
	// background-color red
	.board-content
		width (cell_width * 21)
		height 100%
		flex center center
		// background-color alpha(#000, 25%)
		.dropzone
			position absolute
			left 0
			bottom 0
			for i in 0..30
				&[data-position=\"{i}\"]
					transform 'translateX(%s)' % (cell_width * i)
		.board-card
			position absolute
			left 0
			bottom 0
			transition (0.42s * animation_duration) linear (0.06s * animation_duration)
			&:hover
				z-index 1
			for i in 0..30
				&[data-position=\"{i}\"]
					transform 'translateX(%s)' % (cell_width * i)
			&.board-content-enter-active
				>>> .board-card .board-card-content
					transition 0.25s easeOutQuart
			&.board-content-enter
				>>> .board-card .board-card-content
					transform scale(1.25)
					opacity 0
			&.board-content-leave-active
				>>> .board-card .board-card-content
					transition 0.15s easeOutQuart 0.15s
			&.board-content-leave-to
				>>> .board-card .board-card-content
					transform scale(0.75)
					opacity 0
			&.attack-left, &.attack-right
				z-index 1
			&.pushing
				transition 0.5s easeOutQuart
			


</style>
